import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ITEM_PEDIDO.RESET_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.ITEM_PEDIDO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ITEM_PEDIDO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITEM_PEDIDO.SET_ITENS_SELECIONADOS](state, itens) {
		state.itensSelecionados = itens
	},

	[mutationTypes.ITEM_PEDIDO.RESET_ITENS_SELECIONADOS](state) {
		state.itensSelecionados = []
	},
	[mutationTypes.ITEM_PEDIDO.SET_TODOS_ITENS_SELECIONADOS](state, flag) {
		state.isSelecionouTodosItensPedido = flag
	},
}
